import { render, staticRenderFns } from "./VideoWidget.vue?vue&type=template&id=cb822d96&scoped=true"
import script from "./VideoWidget.vue?vue&type=script&lang=js"
export * from "./VideoWidget.vue?vue&type=script&lang=js"
import style0 from "./VideoWidget.vue?vue&type=style&index=0&id=cb822d96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb822d96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb822d96')) {
      api.createRecord('cb822d96', component.options)
    } else {
      api.reload('cb822d96', component.options)
    }
    module.hot.accept("./VideoWidget.vue?vue&type=template&id=cb822d96&scoped=true", function () {
      api.rerender('cb822d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/VideoWidget.vue"
export default component.exports